/* eslint-disable no-unused-vars */

export enum CreditAssignmentStatus {
  NONE = 'none',
  ASSIGNED_TO_DIFFERENT_USER = 'already_assigned_to_different_user',
  ASSIGNED_TO_SAME_USER = 'already_assigned_to_same_user',
  CREDITS_ASSIGNED = 'free_credits_assigned',
}
